
import axios from 'axios';
import urlUtil from '@uarmRoot/src/util-url';
// import 'vue-multiselect/dist/vue-multiselect.min.css'; // для будущего подсказчика адресов
// import { debounce, omit, maxBy, cloneDeep } from 'lodash'; // для будущего подсказчика адресов


// Vue.extend нельзя! будут ошибки с $attrs и $listeners
export default {
	name: 'geocoder',
	mixins: [], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {},
	components: {},
	data: function () {
		return {}
	},
	methods: {
		geocoderWarn(evt) {
			evt.preventDefault();
			window.alert('Извините, данный функционал находится в процессе разработки ПК ГИП РЖД');
		},
	},
}

